module.exports = __webpack_public_path__ + "static/z16-visual-mobile-34790dc0257ada868e670b3dc1324d12.jpg";